import type { IStatusProps } from 'shared/ui/Status'
import { SurveysStatus } from 'entities/Surveys/api/types'

export const statuses: Record<SurveysStatus, IStatusProps> = {
  [SurveysStatus.Disabled]: {
    title: 'Disabled',
    icon: 'minusCircle',
    emphasis: 'high',
    intent: 'neutral',
  },
  [SurveysStatus.Active]: {
    title: 'Active',
    icon: 'check2',
    emphasis: 'high',
    intent: 'positive',
  },
  [SurveysStatus.Draft]: {
    title: 'Draft',
    icon: 'draft',
    emphasis: 'high',
    intent: 'neutral',
  },
}
